import { render } from "./AdyenCreateOrderPaymentSection.vue?vue&type=template&id=04ac5bfd"
import script from "./AdyenCreateOrderPaymentSection.vue?vue&type=script&lang=js"
export * from "./AdyenCreateOrderPaymentSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__